module.exports = __webpack_public_path__ + "2f426f72c6bc301c2996aa44294ad4db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shop_goods_4.jpg
// module id = 210
// module chunks = 1